import PropTypes from 'prop-types';
import { useContext } from 'react';
import MyAccountLayoutDesktop from './MyAccountLayoutDesktop';
import MyAccountLayoutMobile from './MyAccountLayoutMobile';
import { isMobile } from '../../services/DeviceInformation';
import NavigationTabs from '../../constants/NavigationTabs';
import Loading from '../Loading';
import LoadingScreenContext from '../../services/LoadingScreenContext';

function MyAccountLayout({
    children,
    childrenLoading,
    contentContainerCSS,
    headerDescription,
    mobileHeaderContent,
    selectedTab,
}) {
    const { loading } = useContext(LoadingScreenContext);

    if (isMobile()) {
        return (
            <MyAccountLayoutMobile
                childrenLoading={childrenLoading}
                headerContent={mobileHeaderContent}
                selectedTab={selectedTab}
            >
                {loading && <Loading />}
                {children}
            </MyAccountLayoutMobile>
        );
    }
    return (
        <MyAccountLayoutDesktop
            childrenLoading={childrenLoading}
            contentContainerCSS={contentContainerCSS}
            headerDescription={headerDescription}
            selectedTab={selectedTab}
        >
            {loading && <Loading />}
            {children}
        </MyAccountLayoutDesktop>
    );
}

MyAccountLayout.propTypes = {
    children: PropTypes.node,
    childrenLoading: PropTypes.bool,
    contentContainerCSS: PropTypes.shape({}),
    headerDescription: PropTypes.node,
    mobileHeaderContent: PropTypes.node,
    selectedTab: PropTypes.oneOf([
        NavigationTabs.HOME,
        NavigationTabs.SYSTEMS,
        NavigationTabs.STUDIES,
        NavigationTabs.GENERAL,
        NavigationTabs.EMAILS,
        NavigationTabs.CHANGE_PASSWORD,
        NavigationTabs.RECENT_ACTIVITY,
    ]),
};

export default MyAccountLayout;
